<script setup>
const props = defineProps({
  type: {
    type: String,
    default: 'default',
  },
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="239"
    height="234"
    viewBox="0 0 239 234"
    fill="none"
  >
    <path
      d="M108.845 91.5942C106.004 96.188 100.255 105.572 99.9932 106.36L106.222 111.938L108.845 91.5942Z"
      fill="#CB8500"
    />
    <path
      d="M106.223 112.266L119.009 100.454L113.763 122.766L106.223 112.266Z"
      fill="#CB8500"
    />
    <path
      d="M125.237 140.485C138.842 128.993 148.417 120.128 170.48 98.1567C176.864 104.353 177.415 120.623 177.693 152.625L161.628 154.922L125.237 140.485Z"
      fill="#FCCE00"
    />
    <path
      d="M171.136 170.016L168.186 166.407C176.875 141.312 181.909 128.326 191.791 111.282C186.482 134.309 182.896 146.968 176.054 169.36L171.136 170.016Z"
      fill="#6E4A14"
    />
    <path
      d="M152.449 96.8442C159.827 117.101 163.66 128.452 169.825 148.688H160.973C155.51 127.373 153.982 116.191 152.449 96.8442Z"
      fill="#6E4A14"
    />
    <path
      d="M155.727 147.375C190.882 147.9 209.453 144.037 239 124.079C234.821 150.237 230.781 161.978 219.329 175.594C201.574 194.54 189.722 199.447 165.89 200.203C121.198 201.678 114.819 197.773 102.615 191.016C81.0097 175.462 71.6287 166.06 62.6183 147.375C58.4779 134.888 57.5895 128.816 60.3234 120.797C65.3455 108.775 69.8308 100.782 85.5674 100.782C95.176 101.217 99.6183 103.169 105.566 109.969C110.524 116.243 113.192 120.109 117.696 127.688C126.963 141.335 135.219 145.756 155.727 147.375Z"
      fill="#F6A500"
    />
    <path
      d="M150.481 175.594C158.199 194.097 162.832 204.527 173.103 223.5C141.351 222.506 127.309 216.985 107.533 200.203C104.255 197.421 101.861 187.228 104.255 179.86C107.533 169.77 113.107 163.125 123.598 159.516C132.777 156.754 144.174 161.046 150.481 175.594Z"
      fill="#FCC600"
    />
    <path
      d="M93.4368 138.188C98.6877 138.188 102.944 133.928 102.944 128.672C102.944 123.417 98.6877 119.157 93.4368 119.157C88.1859 119.157 83.9292 123.417 83.9292 128.672C83.9292 133.928 88.1859 138.188 93.4368 138.188Z"
      fill="white"
    />
    <path
      d="M93.4363 132.282C96.1522 132.282 98.354 130.078 98.354 127.36C98.354 124.641 96.1522 122.438 93.4363 122.438C90.7203 122.438 88.5186 124.641 88.5186 127.36C88.5186 130.078 90.7203 132.282 93.4363 132.282Z"
      fill="black"
    />
    <path
      d="M55.406 7.59454L57.3933 12.5826H63.8246L58.6216 15.6653L60.609 20.6534L55.406 17.5706L50.203 20.6534L52.1903 15.6653L46.9873 12.5826H53.4186L55.406 7.59454Z"
      fill="white"
    />
    <path
      d="M85.5219 24.4247L89.0404 31.9495L98.2968 31.1647L91.214 36.6002L94.7318 44.125L86.8372 39.9594L79.7551 45.3949L81.9576 37.385L74.063 33.2195L83.3194 32.4346L85.5219 24.4247Z"
      fill="white"
    />
    <path
      d="M113.386 7.63641L116.84 14.7301L126.099 13.9785L118.975 19.1141L122.43 26.2077L114.573 22.2881L107.449 27.4237L109.716 19.8657L101.858 15.946L111.118 15.1945L113.386 7.63641Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M106.909 53.3784C137.996 36.6286 158.847 14.96 153.479 4.98044C148.111 -4.99922 118.558 0.489089 87.4699 17.2388C56.3818 33.9887 35.5315 55.6571 40.8994 65.637C46.2673 75.6166 75.8208 70.1284 106.909 53.3784ZM107.221 50.6687C136.12 35.0986 155.669 15.2686 150.887 6.37711C146.104 -2.51442 118.8 2.89959 89.9018 18.4696C61.0038 34.0397 41.4542 53.8696 46.2365 62.7612C51.0191 71.6528 78.3229 66.2388 107.221 50.6687Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M92.6636 51.3352C127.331 62.4958 158.457 62.1413 162.186 50.5431C163.241 47.2573 161.985 43.4217 158.853 39.3576C163.763 44.5695 165.955 49.5217 164.633 53.634C160.734 65.7656 127.731 65.9934 90.9175 54.1417C54.1039 42.2903 27.4215 22.8483 31.3207 10.7165C33.1703 4.96108 41.5704 1.88496 53.8202 1.50665C44.4925 2.41812 38.1921 5.2979 36.6403 10.1264C32.9129 21.7246 57.9951 40.1743 92.6636 51.3352Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M78.572 60.5008C117.274 74.0481 152.487 74.0475 157.221 60.4997C161.955 46.9519 134.418 24.9869 95.7165 11.4396C88.0186 8.74506 80.4591 6.58646 73.2491 4.96381C81.8158 6.54164 90.9548 8.95749 100.279 12.2215C138.642 25.6499 165.614 48.3494 160.521 62.9222C155.428 77.4948 120.201 78.4227 81.8387 64.9942C58.0676 56.6735 38.6708 44.7933 28.5654 33.4926C39.6015 43.1775 57.4192 53.0964 78.572 60.5008Z"
      fill="white"
    />
    <path
      v-if="type === 'postman'"
      d="M55.8631 140.399L61.5833 143.134C67.7122 135.667 70.7016 129.862 75.7594 118.513C86.3928 111.523 91.8324 107.228 95.9044 101.352C103.815 89.937 106.831 84.9007 104.36 83.4453C102.867 82.759 102.091 82.9555 100.878 84.9376C94.5048 86.9659 90.6616 88.171 81.4796 90.9065L75.5107 87.922C69.9565 84.7516 65.5625 80.4609 62.3294 76.7304C61.1131 74.2321 60.4017 72.8733 59.0962 70.5128C58.1014 69.0206 55.8239 69.3084 55.117 71.5076C50.6403 85.435 43.6766 115.279 42.4331 141.393C42.4331 143.383 43.9484 145.5 47.1584 146.616C49.446 147.411 52.7099 145.764 55.8631 140.399Z"
      fill="#22548C"
    />
    <path
      v-if="type === 'postman'"
      d="M75.5112 87.9218C70.2232 108.065 66.4385 119.717 55.8636 140.398L61.5837 143.134C67.7421 135.558 70.8109 130.052 75.7599 118.512C82.1153 105.429 82.9134 99.4742 83.7184 90.1602L81.4801 90.9063L75.5112 87.9218Z"
      fill="#4696EF"
    />
    <path
      v-if="type === 'postman'"
      d="M57.853 69.7662C55.9695 98.7594 52.9679 114.93 43.6769 143.631C42.8755 143.753 42.4334 142.885 42.4334 141.89C43.6769 115.279 48.4023 96.6262 54.1225 74.4916C55.247 70.5713 56.0416 69.397 57.853 69.7662Z"
      fill="#4696EF"
    />
    <circle
      v-if="type === 'postman'"
      cx="2.81376"
      cy="2.81376"
      r="2.81376"
      transform="matrix(-0.707107 0.707107 0.707107 0.707107 71.5317 111.797)"
      fill="#F2B76F"
    />
    <path
      v-if="type === 'postman'"
      d="M78.2471 89.6627C76.2531 98.6213 74.9014 103.736 70.7859 113.538L73.7704 115.528C77.4394 105.947 79.1326 100.562 80.9828 90.9063L78.2471 89.6627Z"
      fill="#F2B76F"
    />
    <path
      v-if="type === 'postman'"
      d="M100.133 87.1758C96.6445 96.4773 93.327 101.048 82.9722 109.808"
      stroke="#F2B76F"
      stroke-width="3"
      stroke-linecap="round"
    />
    <path
      v-if="type === 'postman'"
      d="M0.690646 195.436C0.102238 193.764 1.11553 192.139 2.95389 191.807L27.8682 187.306C29.7066 186.974 31.6738 188.06 32.2622 189.732L37.5804 204.843C38.1688 206.515 37.1555 208.14 35.3171 208.472L10.4028 212.973C8.56446 213.305 6.59717 212.219 6.00877 210.547L0.690646 195.436Z"
      fill="#4F2B1B"
    />
    <path
      v-if="type === 'postman'"
      d="M32.3763 187.899L31.5965 187.236L20.4171 203.398L0.264682 193.072L0 193.929L20.9321 204.919L32.3763 187.899Z"
      fill="white"
    />
    <path
      v-if="type === 'postman'"
      d="M62.4674 186.751C63.2536 185.434 65.0943 184.98 66.5788 185.738L89.9266 197.65C91.4111 198.408 91.9772 200.09 91.191 201.407L82.7961 215.473C82.01 216.79 80.1692 217.244 78.6847 216.487L55.3369 204.574C53.8524 203.816 53.2863 202.134 54.0725 200.817L62.4674 186.751Z"
      fill="#4F2B1B"
    />
    <path
      v-if="type === 'postman'"
      d="M92 200.605L91.9159 199.698L71.0015 203.883L63.5995 185L62.7398 185.417L70.226 205.207L92 200.605Z"
      fill="white"
    />
    <path
      v-if="type === 'postman'"
      d="M19.9994 219.953C19.7819 218.73 21.4054 217.25 23.6257 216.647L51.5646 209.059C53.7849 208.456 55.7612 208.959 55.9788 210.182L58.232 222.851C58.4496 224.074 56.8261 225.555 54.6058 226.158L26.6669 233.745C24.4466 234.348 22.4703 233.845 22.2527 232.622L19.9994 219.953Z"
      fill="#4F2B1B"
    />
    <path
      v-if="type === 'postman'"
      d="M55.2276 208.975L54.5549 208.557L39.1955 223.219L20.2937 217.908L19.8244 218.637L39.3989 224.366L55.2276 208.975Z"
      fill="white"
    />
    <path
      v-if="type === 'default'"
      d="M22.2938 234C28.45 234 33.4406 229.593 33.4406 224.156C33.4406 218.72 28.45 214.313 22.2938 214.313C16.1376 214.313 11.147 218.72 11.147 224.156C11.147 229.593 16.1376 234 22.2938 234Z"
      fill="#EF7D18"
    />
    <path
      v-if="type === 'default'"
      d="M42.2922 211.031C47.9052 211.031 52.4554 206.624 52.4554 201.188C52.4554 195.751 47.9052 191.344 42.2922 191.344C36.6792 191.344 32.1289 195.751 32.1289 201.188C32.1289 206.624 36.6792 211.031 42.2922 211.031Z"
      fill="#EF7D18"
    />
    <path
      v-if="type === 'default'"
      d="M59.0125 225.469C62.6338 225.469 65.5695 221.502 65.5695 216.609C65.5695 211.717 62.6338 207.75 59.0125 207.75C55.3912 207.75 52.4556 211.717 52.4556 216.609C52.4556 221.502 55.3912 225.469 59.0125 225.469Z"
      fill="#EF7D18"
    />
    <path
      v-if="type === 'default'"
      d="M25.2442 184.781C29.0465 184.781 32.129 182.431 32.129 179.531C32.129 176.632 29.0465 174.281 25.2442 174.281C21.4418 174.281 18.3594 176.632 18.3594 179.531C18.3594 182.431 21.4418 184.781 25.2442 184.781Z"
      fill="#EF7D18"
    />
    <path
      v-if="type === 'default'"
      d="M9.17972 196.594C14.2495 196.594 18.3594 191.599 18.3594 185.438C18.3594 179.276 14.2495 174.281 9.17972 174.281C4.1099 174.281 0 179.276 0 185.438C0 191.599 4.1099 196.594 9.17972 196.594Z"
      fill="#EF7D18"
    />
  </svg>
</template>
